module.exports = __webpack_public_path__ + "static/media/press_content_03.1fa0f8f3.png";